<template>
    <header id="header">

        <!-- Logo and Navbar --><div 
                @click="this.isActive = !this.isActive" 
                class="menu" 
                style="width: 32px; height: 100%; fill: currentcolor;">
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    height="24" 
                    viewBox="0 0 24 24" 
                    width="24" 
                    focusable="false" 
                    style="pointer-events: none; display: inherit; width: 100%; height: 100%;">
                    <path d="M21 6H3V5h18v1zm0 5H3v1h18v-1zm0 6H3v1h18v-1z"></path>
                </svg>
            </div>


        <div class="logo-navbar centered">
            <!-- Menu Icon -->
            
        
 <RouterLink to="/"><img class="logo" width="40" src="/img/am_blanc.png" alt="logo du site web"></RouterLink>
           


        </div>

        
                <ul class="navbar-list">
                    <li><RouterLink to="/" active-class="active-header-link"><img class="pictogramme-header" src="/img/pictogramme/header/home.svg">Accueil</RouterLink></li>
                    <li><RouterLink to="/a-propos" active-class="active-header-link"><img class="pictogramme-header" src="/img/pictogramme/header/aPropos.svg">À Propos</RouterLink></li>
                    <li><RouterLink to="/competences" active-class="active-header-link"><img src="/img/pictogramme/header/stars.svg" class="pictogramme-header">Compétences</RouterLink></li>
                    <li><RouterLink to="/portfolio/tous" active-class="active-header-link" :class="{ 'active-header-link': $route.path.startsWith('/portfolio') }"><img src="/img/pictogramme/header/portfolio.png" class="pictogramme-header">Portfolio</RouterLink></li>
                </ul>
            

        

        
        <Transition name="fade-slide" mode="in-out">
    <div v-if="isActive" class="navbar-responsive">
        <div class="navbar-responsive-container">

            
                <span @click="isActive = !isActive" class="close-btn">✖</span>
           

          
            <div class="navbar-responsive-list-container">
                <ul class="navbar-responsive-list">
                    <RouterLink 
                        active-class="active-header-link" 
                        class="header-links" 
                        to="/">
                        <li>
                            <img class="pictogramme-header" src="/img/pictogramme/header/home.svg">
                            Accueil
                        </li>
                    </RouterLink>

                    <RouterLink 
                        active-class="active-header-link" 
                        class="header-links" 
                        to="/a-propos">
                        <li>
                            <img class="pictogramme-header" src="/img/pictogramme/header/aPropos.svg">
                            À propos de moi
                        </li>
                    </RouterLink>

                    <RouterLink 
                        active-class="active-header-link" 
                        class="header-links" 
                        to="/competences">
                        <li>
                            <img src="/img/pictogramme/header/stars.svg" class="pictogramme-header">
                            Compétences
                        </li>
                    </RouterLink>

                    <RouterLink 
                        active-class="active-header-link" 
                        class="header-links" 
                        :class="{ 'active-header-link': $route.path.startsWith('/portfolio') }"
                        to="/portfolio/tous">
                        <li>
                            <img src="/img/pictogramme/header/portfolio.png" class="pictogramme-header">
                            Portfolio
                        </li>
                    </RouterLink>

                </ul>
            </div>
        </div>
    </div>
</Transition> 


    </header>
</template>







































<script>



export default {
    name: 'Header',
    components: {
    },
    data() {
        return {
            isActive: false,
        }
    },
    watch: {
        isActive(newValue) {
            if (newValue) {
                document.querySelector('#main').style.overflow = 'hidden';
            } else {
                document.querySelector('#main').style.overflow = 'revert-layer';
            }
        },
    },
}




</script>


























<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .25s cubic-bezier(0.23, 1, 0.320, 1);
}

.fade-slide-enter-from,
.fade-slide-leave-to {
transform: scale(0.5);
  opacity: 0;
}

header {
    width: 100%;
    margin: 0 auto;
    position: sticky;
    top: 0;
    z-index: 10000;
    transition: all 0.75s ease;
    display: flex;
    flex-direction: row-reverse;
    padding:0 2rem;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    justify-content: space-between;
    background: var(--hard-blue);
    box-shadow: var(--box-shadow-1);
    border-bottom: var(--transparent-gray-border) ;
    max-height: 60px;
}

.navbar-list{
    display: flex;
    align-items: center;
    gap:2.5rem;
}

.navbar-list .active-header-link{
    background: var(--yellow-white) !important;
  box-shadow: 0px 0px 0px 2px #141428, 0px 0px 0px 4px var(--yellow-white);
}

.navbar-list li{
    white-space: nowrap;
    font-family: var(--font-text);
    font-size: 1.5rem;
}

.navbar-list a{
    transition: 0.25s ease-out;
    padding:5px 8px;
    text-decoration: none;
    border: 1px solid var(--gray);
    display: flex;
    align-items: center;
    gap:0.75rem;
    text-transform: uppercase;
}

.navbar-list a:hover{
    background: var(--yellow-white);
    color:var(--hard-blue);
    font-weight: 800 !important;
}

.active-header-link{
    background: var(--yellow-white) !important;
    color:var(--hard-blue) !important;
    font-weight: 800 !important;
}

.active-header-link .pictogramme-header,.navbar-list a:hover .pictogramme-header{
    filter: invert(0) !important;
}

.navbar-responsive-container ul {
    min-width: 130px;
}

.navbar-responsive-container a:hover:after {
    transform: scale(1);
}

.navbar-responsive-list li a:hover{
    background:var(--gray-hover-1)
}

.header-links {
    white-space: nowrap;
    font-size: 15px;
    font-family: var(--font-text);
    display: flex;
    justify-content: center;
    align-items: center;
}

.navbar-responsive-container li {
    margin: 2px 0;
    width: -webkit-fill-available;
    display: flex;
    align-items: center;
    padding: 12px 20px 12px 0;
    transition: all 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    font-weight: 900;
    text-transform: uppercase;
    font-size: 6.5vw;
    letter-spacing: -1.5px;
}

.navbar-responsive-list-container{
    width:100%
}

 /* .pictogramme-header {
    width: 18px;
    height:18px;
    filter: invert(0.85);
    margin:0 1.5rem;
} */

.navbar-responsive-container .pictogramme-header {
    width: 7vw;
    height: 7vw;
    filter: invert(1);
    transition: all 0.25s ease-in;
    margin:3rem;
}

.navbar-list .pictogramme-header {
    width: 18px;
    height:18px;
    filter: invert(1);
    transition: all 0.25s ease-in;
}

.right-header {
    justify-self: flex-end;
    margin-right: 1rem;
}

.name {
    transition: 0.15s cubic-bezier(0.075, 0.82, 0.165, 1);
    justify-self: center;
    text-transform: uppercase;
    font-weight: 300;
    color: var(--yellow-white);
}

.name:hover {
    font-weight: 900;
}

.logo-navbar {
    justify-self: flex-start;
    margin:.7rem 0;
}

.logo-navbar, .navbar-list ul {
    height:-webkit-fill-available;
}

.menu {
    display: none;
    padding: 0;
    border-radius: 0;
    transition: 0.1s ease;
    border: 1px solid rgb(136, 134, 134);
    transition: all 0.25s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}

.menu:hover {
    background: var(--yellow-white);
    fill:var(--hard-blue) !important;
}

.navbar-responsive {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
}

.navbar-responsive-container {
    display: grid;
    place-items: center;
    width:100%;
    background: var(--hard-blue);
    position: relative;
    height: -webkit-fill-available;
    box-shadow: var(--box-shadow-1);
}

.close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 30px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    transition: all 0.75s ease-in;
    width:50px;
    height:50px;
}

.navbar-responsive-title {
    background: var(--gray);
    padding: 4px;
    margin-bottom: 1.15rem;
    transition: 0.1s ease-out;
    border-radius: 6px;
    font-weight: 600;
    font-size: 1.5rem;
}

.social-media-img-container {
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
}

.hidden-element {
    transition: 0.55s;
    color: var(--black);
    font-size: 1.25rem;
    white-space: nowrap;
}

/* .actif {
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
    transition: 0.1s ease-out;
}

.inactif {
    left: -200vw;
} */

@media (max-width:605px){
    .name {
        opacity: 0;
    }
}

@media (max-width:730px){
    header {
        width:100%;
        border-radius: 0;
    }
    .navbar-list {
        gap:1.5vw;
    }
}

@media (max-width:620px){
    .navbar-list {
        display: none;
    }
    .menu {
        display: flex;
    }
    header{
        flex-direction: row;
    }
}

@media (min-width:620px){
    .navbar-responsive{
        display: none;
    }
}

</style>